import gql from 'graphql-tag'

export const deleteJobRequisitionMutation = gql`
  mutation DeleteJobRequisition($requisitionId: String!) {
    deleteJobRequisition(requisitionId: $requisitionId)
  }
`
